import { Layout, Menu, Typography } from 'antd'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import AlertPage from './../pages/alert'
import ApiSetting from './../pages/apiKey'
import BatchRegister from './../pages/batch'
import DeviceList from './../pages/deviceList'
import GatewayList from './../pages/gatewayList'
import ExtractRawData from './extractRawData'
import RawDataList from './rawDataList'
import Graphic from './../pages/graphic'
import HistoryList from './../pages/history'
import Upload from './../pages/upload'
import UploadGateway from './../pages/uploadGateway'
import ExtractReport from './../pages/extractReport'
import ReportList from './../pages/reportList'
import Home from './home'
import { logout } from '../state'
import {
    AlertOutlined,
    DatabaseOutlined,
    DownloadOutlined,
    ForkOutlined,
    HistoryOutlined,
    HomeOutlined,
    LineChartOutlined,
    LogoutOutlined,
    SettingOutlined,
    UnorderedListOutlined,
    UploadOutlined,
} from '@ant-design/icons'
const { Title } = Typography
const { Content, Sider } = Layout
// const { SubMenu } = Menu

interface IProps extends RouteComponentProps {}

export const Dashboard: React.FC<IProps> = props => {
    const [state, setState] = React.useState({
        collapsed: false,
        current: props.location.pathname,
    })

    const dispatch = useDispatch()

    const toggle = () => {
        setState({ ...state, collapsed: !state.collapsed })
    }

    const handleClick = (e: any) => {
        setState({ ...state, current: e.key })
    }

    const handleLogoutClick = () => {
        dispatch(logout())
    }

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider collapsible collapsed={state.collapsed} onCollapse={toggle}>
                <div className="logo">
                    <Title level={2} style={{ color: '#fff' }}>
                        TickTack Technology
                    </Title>
                </div>
                <Menu
                    theme="dark"
                    defaultSelectedKeys={['/dashboard']}
                    mode="inline"
                    selectedKeys={[state.current !== props.location.pathname ? props.location.pathname : state.current]}
                    onClick={handleClick}
                >
                    <Menu.Item key="/dashboard">
                        <HomeOutlined />
                        <span>Home</span>
                        <Link to="/dashboard" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/deviceList">
                        <UnorderedListOutlined />
                        <span>Device List</span>
                        <Link to="/dashboard/deviceList" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/gatewayList">
                        <UnorderedListOutlined />
                        <span>Gateway List</span>
                        <Link to="/dashboard/gatewayList" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/history">
                        <HistoryOutlined />
                        <span>History</span>
                        <Link to="/dashboard/history" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/upload">
                        <UploadOutlined />
                        <span>Update Device</span>
                        <Link to="/dashboard/upload" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/uploadGateway">
                        <UploadOutlined />
                        <span>Update Gateway</span>
                        <Link to="/dashboard/uploadGateway" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/graphic">
                        <LineChartOutlined />
                        <span>Graphic</span>
                        <Link to="/dashboard/graphic" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/batch">
                        <ForkOutlined />
                        <span>Sensor Control</span>
                        <Link to="/dashboard/batch" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/extractRawData">
                        <DownloadOutlined />
                        <span>Extract Raw Data</span>
                        <Link to="/dashboard/extractRawData" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/rawDataList">
                        <DatabaseOutlined />
                        <span>Raw Data List</span>
                        <Link to="/dashboard/rawDataList" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/extractReport">
                        <DownloadOutlined />
                        <span>Extract Report</span>
                        <Link to="/dashboard/extractReport" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/reportList">
                        <DatabaseOutlined />
                        <span>Report List</span>
                        <Link to="/dashboard/reportList" />
                    </Menu.Item>

                    {/* <Menu.Item key="/dashboard/extractMap">
                        <Icon type="upload" />
                        <span>Extract Map</span>
                        <Link to="/dashboard/extractMap" />
                    </Menu.Item> */}

                    <Menu.Item key="/dashboard/setting">
                        <SettingOutlined />
                        <span>Setting</span>
                        <Link to="/dashboard/setting" />
                    </Menu.Item>

                    <Menu.Item key="/dashboard/alert">
                        <AlertOutlined />
                        <span>Alert</span>
                        <Link to="/dashboard/alert" />
                    </Menu.Item>

                    <Menu.Item key="/logout" onClick={handleLogoutClick}>
                        <LogoutOutlined />
                        <span>Logout</span>
                    </Menu.Item>
                </Menu>
            </Sider>
            <Layout>
                <Content style={{ margin: '25px' }}>
                    <Route exact path="/dashboard" component={Home} />
                    <Route exact path="/dashboard/deviceList" component={DeviceList} />
                    <Route exact path="/dashboard/gatewayList" component={GatewayList} />
                    <Route exact path="/dashboard/history" component={HistoryList} />
                    <Route exact path="/dashboard/upload" component={Upload} />
                    <Route exact path="/dashboard/uploadGateway" component={UploadGateway} />
                    <Route exact path="/dashboard/graphic" component={Graphic} />
                    <Route exact path="/dashboard/batch" component={BatchRegister} />
                    <Route exact path="/dashboard/extractRawData" component={ExtractRawData} />
                    <Route exact path="/dashboard/rawDataList" component={RawDataList} />
                    <Route exact path="/dashboard/extractReport" component={ExtractReport} />
                    <Route exact path="/dashboard/reportList" component={ReportList} />
                    <Route exact path="/dashboard/setting" component={ApiSetting} />
                    <Route exact path="/dashboard/alert" component={AlertPage} />
                </Content>
            </Layout>
        </Layout>
    )
}

export * from './login'
